import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import {
  QuoteTemplateItem,
  QuoteTemplateItemCreate
} from "src/app/backend/models/quote-template/quote-template-item";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import {
  QuoteTemplate,
  QuoteTemplateCreate,
  QuoteTemplateUpdate
} from "../models/quote-template/quote-template";

@Injectable()
export class QuoteTemplateBackend {
  constructor(private http: HttpClient) {}

  load(id: string): Observable<QuoteTemplate> {
    return this.http.get<QuoteTemplate>(
      `${environment.snoots.api.billing}/templates/${id}`
    );
  }

  list(request: PageRequest): Observable<PaginatedResult<QuoteTemplate>> {
    return this.http.get<PaginatedResult<QuoteTemplate>>(
      `${environment.snoots.api.billing}/templates`,
      {
        params: {
          p: request.page,
          s: request.pageSize,
          ...request.filterValues
        }
      }
    );
  }

  @UserNotify({
    successMessage: marker("Modello preventivo creato"),
    errorMessage: marker("Impossibile creare il modello"),
    progressIndeterminate: true,
    progressMessage: marker("Crezione modello preventivo")
  })
  create(payload: QuoteTemplateCreate): Observable<QuoteTemplate> {
    return this.http.post<QuoteTemplate>(
      `${environment.snoots.api.billing}/templates`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Modello preventivo aggiornato"),
    errorMessage: marker("Impossibile aggiornare il modello")
  })
  update(id: string, payload: Partial<QuoteTemplateUpdate>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.billing}/templates/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Modello preventivo aggiornato"),
    errorMessage: marker("Impossibile aggiornare il template")
  })
  addItem(
    id: string,
    quoteItemCreate: QuoteTemplateItemCreate
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.billing}/templates/${id}/items`,
      quoteItemCreate
    );
  }

  @UserNotify({
    successMessage: marker("Item aggiornato"),
    errorMessage: marker("Impossibile aggiornare l'item selezionato")
  })
  updateItem(
    id: string,
    itemId: string,
    request: Partial<QuoteTemplateItem>
  ): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.billing}/templates/${id}/items/${itemId}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Rimosso"),
    errorMessage: marker("Impossibile rimuovere la riga")
  })
  removeItem(id: string, itemId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.billing}/templates/${id}/items/${itemId}`
    );
  }

  @UserNotify({
    successMessage: marker("Modello preventivo eliminato"),
    errorMessage: marker("Impossibile eliminare il modello")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.billing}/templates/${id}`
    );
  }
}
